import { map, pick } from 'lodash'

const transformToSaveIngredientsArgs = data =>
  map(data, (node, index) => ({
    ...pick(node, [
      'id',
      'name',
      'parentId',
      'isCurationEnabled',
      'isWholeFood',
      'isVague',
    ]),
    children: transformToSaveIngredientsArgs(node.children),
    position: index,
  }))

export default transformToSaveIngredientsArgs
